import * as THREE from 'three';

export class LandingZonePreview {
  readonly object3D = new THREE.Group();
  private readonly ringMaterial = new THREE.MeshBasicMaterial({
    color: 0xffffff,
    transparent: true,
    opacity: 0,
    depthWrite: false,
  });
  private opacity = 0;

  constructor() {
    this.object3D.name = 'LandingZonePreview';
    const ring = new THREE.Mesh(new THREE.TorusGeometry(1, 0.012, 8, 128), this.ringMaterial);
    ring.name = 'LandingZonePreviewRing';
    ring.rotation.x = Math.PI / 2;
    this.object3D.add(ring);
    this.object3D.visible = false;
  }

  update(target: THREE.Vector3 | null, clubCarryMeters: number, deltaSeconds: number): void {
    const desiredOpacity = target ? 1 : 0;
    this.opacity = THREE.MathUtils.damp(this.opacity, desiredOpacity, 7, deltaSeconds);
    this.object3D.visible = this.opacity > 0.01;
    this.ringMaterial.opacity = this.opacity * 0.42;
    if (!target) return;

    const radius = THREE.MathUtils.clamp(clubCarryMeters * 0.045, 2.2, 8.5);
    this.object3D.position.set(target.x, target.y + 0.055, target.z);
    this.object3D.scale.set(radius, radius, radius);
  }

  dispose(): void {
    this.object3D.traverse((child) => {
      if (child instanceof THREE.Mesh) child.geometry.dispose();
    });
    this.ringMaterial.dispose();
  }
}
